import { useAuth } from "@clerk/clerk-react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

export async function apiCall(
  method: string,
  endpoint: string,
  body?: unknown,
  token?: string
): Promise<unknown> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const url = `${API_BASE_URL}${endpoint}`;
  const options: RequestInit = {
    method,
    headers,
  };

  if (body && (method === "POST" || method === "PUT" || method === "PATCH")) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(err.detail || `HTTP ${response.status}`);
  }

  return response.json();
}

export function useApiClient() {
  const { getToken } = useAuth();

  const ensureApiPrefix = (endpoint: string) => {
    return endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`;
  };

  return {
    get: async (endpoint: string) => {
      const token = await getToken();
      return apiCall("GET", ensureApiPrefix(endpoint), undefined, token);
    },
    post: async (endpoint: string, body: unknown) => {
      const token = await getToken();
      return apiCall("POST", ensureApiPrefix(endpoint), body, token);
    },
    delete: async (endpoint: string) => {
      const token = await getToken();
      return apiCall("DELETE", ensureApiPrefix(endpoint), undefined, token);
    },
  };
}
